import React from "react";
import { Box, Icon, Text } from "components";
import { useTranslation } from "react-i18next";
import styled, { keyframes, useTheme } from "styled-components";
import { getTranslationsStyle } from "utils/arabisation.util";

const SquareStyled = styled.div`
  outline: 9999px solid rgba(0, 0, 0, 0.3); //This creates a fullscreen opacity around the square
  position: absolute;
  left: 4%;
  top: 20%;
  height: 45%;
  width: 93%;
  border-radius: 20px;
`;

const getBorderColor = (props) => {
  if (props.isScanUnsuccessful) return props.theme.colors.error;
  if (props.isScanSuccessful) return props.theme.colors.success;
  return props.theme.colors.backgroundQuaternary;
};

const TopRightCornerStyled = styled.div`
  width: 50px;
  height: 60px;
  position: absolute;
  right: 2.5%;
  top: 19.7%;
  border-top-right-radius: 20px;
  border-top: 4px solid ${getBorderColor};
  border-right: 4px solid ${getBorderColor};
`;

const TopLeftCornerStyled = styled.div`
  width: 50px;
  height: 60px;
  position: absolute;
  left: 3.3%;
  top: 19.7%;
  border-top-left-radius: 20px;
  border-top: 4px solid ${getBorderColor};
  border-left: 4px solid ${getBorderColor};
`;

const BottomLeftCornerStyled = styled.div`
  width: 50px;
  height: 60px;
  position: absolute;
  left: 3.3%;
  bottom: 34.7%;
  border-bottom-left-radius: 20px;
  border-bottom: 4px solid ${getBorderColor};
  border-left: 4px solid ${getBorderColor};
`;

const BottomRightCornerStyled = styled.div`
  width: 50px;
  height: 60px;
  position: absolute;
  right: 2.5%;
  bottom: 34.7%;
  border-bottom-right-radius: 20px;
  border-bottom: 4px solid ${getBorderColor};
  border-right: 4px solid ${getBorderColor};
`;

const slideInFromBottom = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`;

const SuccessOverlay = styled.div`
  position: absolute;
  top: 0;
  z-index: 100;
  animation: ${slideInFromBottom} 0.5s ease-out;
`;

const FixedOverlay = ({
  isScanUnsuccessful,
  isScanSuccessful,
  onClose,
  showCloseButton = true,
}) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  return (
    <>
      <SquareStyled />
      <TopRightCornerStyled
        isScanUnsuccessful={isScanUnsuccessful}
        isScanSuccessful={isScanSuccessful}
      />
      <TopLeftCornerStyled
        isScanUnsuccessful={isScanUnsuccessful}
        isScanSuccessful={isScanSuccessful}
      />
      <BottomLeftCornerStyled
        isScanUnsuccessful={isScanUnsuccessful}
        isScanSuccessful={isScanSuccessful}
      />
      <BottomRightCornerStyled
        isScanUnsuccessful={isScanUnsuccessful}
        isScanSuccessful={isScanSuccessful}
      />
      {isScanSuccessful && (
        <SuccessOverlay>
          <Box
            h="60px"
            w="100vw"
            d="flex"
            justifyContent="center"
            alignItems="center"
            backgroundColor="success_3"
          >
            <Text
              color="textQuaternary"
              fontWeight="semibold"
              fontSize="l"
              style={getTranslationsStyle(i18n, { textAlign: "center" })}
            >
              {t("smart_gate.scan_successful")}
            </Text>
          </Box>
        </SuccessOverlay>
      )}
      {showCloseButton && (
        <Box
          onClick={onClose}
          position="absolute"
          top="30px"
          left="30px"
          style={{ zIndex: theme.zIndex.modalClose }}
        >
          <Icon size="xl" color="backgroundQuaternary" name="Close"></Icon>
        </Box>
      )}
    </>
  );
};

export default FixedOverlay;
